<template>
  <div class="fadeIn" v-if="report">
    <RegionPrint id="print" :report="report" />
    <b-card>
      <div slot="header">
        <strong>Сводный отчет о статусе комплексной диагностики компаний в регионе (с учетом этапов комплексной диагностики)</strong>
      </div>
      <b-row>
        <b-col md="8">
          <h4>Данные по региону</h4>
          <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
              <th>Регион</th>
              <th>Дата инф. мероприятия (в CRM)</th>
              <th>В процессе диагностики</th>
              <th>Архив</th>
              <th>Завершили диагностику</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{report.data.region}}</td>
              <td>{{report.data.event_date | formatDate}}</td>
              <td>{{report.data.progress_count}}</td>
              <td>{{report.data.archive_count}}</td>
              <td>{{report.data.final_count}}</td>
            </tr>
            </tbody>
          </table>
          <hr/>
          <h4>В процессе диагностики</h4>
          <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
              <th>Этап комплексной диагностики</th>
              <th>Число компаний</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Оценка экспортной зрелости</td>
              <td>{{report.in_progress.form_report}}</td>
            </tr>
            <tr>
              <td>Аудит на предмет стоп-факторов</td>
              <td>{{report.in_progress.stop_factors_report}}</td>
            </tr>
            <tr>
              <td>Экспресс-оценка финансового состояния</td>
              <td>{{report.in_progress.finance_express_report}}</td>
            </tr>
            <tr>
              <td>Верификация анкеты экспортной зрелости</td>
              <td>{{report.in_progress.verify_form_report}}</td>
            </tr>
            <tr>
              <td>Структурированное интервью с представителями компании</td>
              <td>{{report.in_progress.interview_report}}</td>
            </tr>
            <tr>
              <td>Оценка финансового состояния компании</td>
              <td>{{report.in_progress.finance_report}}</td>
            </tr>
            </tbody>
          </table>
          <hr/>
          <h4>Этап комплексной диагностики, на котором компании перешли в Архив</h4>
          <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
              <th>Этап комплексной диагностики</th>
              <th>Число компаний</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Оценка экспортной зрелости</td>
              <td>{{report.archive.form_report}}</td>
            </tr>
            <tr>
              <td>Аудит на предмет стоп-факторов</td>
              <td>{{report.archive.stop_factors_report}}</td>
            </tr>
            <tr>
              <td>Экспресс-оценка финансового состояния</td>
              <td>{{report.archive.finance_express_report}}</td>
            </tr>
            <tr>
              <td>Верификация анкеты экспортной зрелости</td>
              <td>{{report.archive.verify_form_report}}</td>
            </tr>
            <tr>
              <td>Структурированное интервью с представителями компании</td>
              <td>{{report.archive.interview_report}}</td>
            </tr>
            <tr>
              <td>Оценка финансового состояния компании</td>
              <td>{{report.archive.finance_report}}</td>
            </tr>
            </tbody>
          </table>
          <!--<b-table striped hover bordered responsive="sm" class="table-align-middle mb-0" :items="report.companies" :fields="fields"></b-table>-->
        </b-col>
        <b-col md="4">
          <!--<ManagerDoughutChart chartId="chart-managers" :data="[report.total.verify, report.total.event, report.total.candidate, report.total.archive]"></ManagerDoughutChart>-->
          <DoughutChart
            :colors="['#ffc107','#4dbd74','#f5302e']"
            :data="[report.data.progress_count, report.data.final_count, report.data.archive_count]"
            :labels="['В прогрессе диагностики', 'Завершили диагностику', 'Архив']"
          />
        </b-col>
      </b-row>
      <div slot="footer">
        <div class="text-right">
          <b-button variant="info" @click="print('admin')" class="text-white">
            <i class="fa fa-print"></i> Печать
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
    import client from "../../backend/client";
    import ManagerDoughutChart from "../charts/ManagerDoughutChart";
    import ManagerPrint from "./ManagerPrint";
    import DoughutChart from "../charts/DoughutChart";
    import RegionPrint from "./RegionPrint";
    export default {
        name: "Manager",
        components: {RegionPrint, DoughutChart, ManagerPrint, ManagerDoughutChart},
        data() {
            return {
                regionId: null,
                report: null,
                fields: [
                    {
                        key: 'name',
                        label: 'Название',
                        sortable: true
                    },
                    {
                        key: 'ogrn',
                        label: 'ОГРН',
                        sortable: true
                    },
                    {
                        key: 'status',
                        label: 'Статус',
                        sortable: true
                    }
              ]
            }
        },
        mounted() {
            this.regionId = this.$route.params.region;
            client.get('api/crm/reports/' + this.regionId + '/region')
                .then(res => {
                    this.report = res.data
                })
        },
        methods: {
            print() {
                let block = window.open('', 'PRINT');
                block.document.write('<html><head>');
                block.document.write('<style>@page { size: portrait;} body{ margin: 10mm 5mm 5mm 25mm; }</style>');
                block.document.write('</head><body>');
                block.document.write(document.getElementById('print').innerHTML);
                block.document.write('</body></html>');
                block.document.close();
                block.focus();
                block.print();
                block.close();
                return true;
            },
        }
    }
</script>

<style scoped>
  #print {
    display: none;
  }
</style>
